<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="80%"
      content-class="charts-dialog-content"
    >
      <div class="solutions-chart-container">
        <div class="title-container">
          <span class="title">Solution's Charts</span>
        </div>
        <highcharts
          :ref="getSolutionsSpeedChartData.tag"
          :options="getSolutionsSpeedChartData"
        />
        <highcharts
          :ref="getSolutionsDailyConsumptionChartData.tag"
          :options="getSolutionsDailyConsumptionChartData"
        />

        <div class="actions-container">
          <v-btn color="primary" @click="dialog = false" outlined>Close</v-btn>
        </div>
      </div>
    </v-dialog>
    <v-btn
      icon
      @click="dialog = true"
      color="white"
      style="border: 1px solid white"
    >
      <v-icon>mdi-chart-line</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      dialog: false, // Controls the dialog visibility
    };
  },
  computed: {
    ...mapState("weatherRouting/voyageDetailsModule", [
      "fetchSolutionsLoading",
    ]),
    ...mapGetters("weatherRouting/voyageDetailsModule", [
      "getSolutionsSpeedChartData",
      "getSolutionsDailyConsumptionChartData",
    ]),
  },
};
</script>

<style scoped>
.title {
  color: var(--color-text) !important;
  font-size: 1.2rem;
  font-weight: 600;
}
.solutions-chart-container {
  background-color: var(--color-bg) !important;
  border-radius: 10px;
  padding: 10px;
  border: 1px solid var(--color-secondary) !important;
}
.actions-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.title-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

<style>
/*This seems to be fixing the tooltip alignment issue (not quite sure how though) */
.charts-dialog-content {
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  z-index: 1000 !important;
  max-height: 90vh !important;
  overflow-y: auto !important;
}
</style>
